export const actionTypes = {
  // get
  GET_FOREX_RATE_CATEGORY_START: 'GET_FOREX_RATE_CATEGORY_START',
  GET_FOREX_RATE_CATEGORY_SUCCESS: 'GET_FOREX_RATE_CATEGORY_SUCCESS',
  GET_FOREX_RATE_CATEGORY_FINISH: 'GET_FOREX_RATE_CATEGORY_FINISH',
}
